module.exports = __webpack_public_path__ + "media/src/images/icons/plus/white-e3162bf0a052c6575e3461749ca9ea34.svg";